import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  style: {},
  class: "header align-items-stretch"
}
const _hoisted_2 = { class: "container d-flex align-items-stretch justify-content-between" }
const _hoisted_3 = {
  class: "d-flex align-items-center d-lg-none ms-n3 me-1",
  title: "Show aside menu"
}
const _hoisted_4 = {
  class: "btn btn-icon btn-active-light-primary",
  id: "kt_aside_mobile_toggle"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2x mt-1" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "d-lg-none"
  }, [
    /*#__PURE__*/_createVNode("img", {
      alt: "Logo",
      src: "/media/logo-okr.png",
      class: "h-30px"
    })
  ])
], -1)
const _hoisted_7 = { class: "d-flex align-items-stretch justify-content-between flex-lg-grow-1" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex align-items-stretch",
  id: "kt_header_menu_nav"
}
const _hoisted_9 = {
  key: 1,
  class: "page-title d-flex align-items-center mb-5 mb-lg-0"
}
const _hoisted_10 = { class: "d-flex align-items-center text-dark my-1 fs-4" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Documentation ")
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "h-20px border-gray-200 border-start mx-4" }, null, -1)
const _hoisted_13 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-6 my-1" }
const _hoisted_14 = { class: "breadcrumb-item text-muted" }
const _hoisted_15 = { class: "botones" }
const _hoisted_16 = {
  key: 0,
  href: "/docs",
  target: "_BLANK",
  class: "btn btn-sm btn-primary ms-4"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "bi bi-file-earmark-text" }, null, -1)
const _hoisted_18 = {
  key: 1,
  type: "button",
  class: "btn btn-sm btn-success ms-4",
  "data-bs-toggle": "modal",
  "data-bs-target": "#_app_organization_new_form_modal",
  id: "kt_toolbar_primary_button"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "bi bi-plus" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "bi bi-plus" }, null, -1)
const _hoisted_21 = { class: "d-flex align-items-stretch flex-shrink-0 animated animate__bounce" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_KTMenu = _resolveComponent("KTMenu")
  const _component_router_link = _resolveComponent("router-link")
  const _component_KTTopbar = _resolveComponent("KTTopbar")
  const _component_ELearningHelperModal = _resolveComponent("ELearningHelperModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Text/Menu.svg" })
          ])
        ])
      ]),
      _hoisted_6,
      _createVNode("div", _hoisted_7, [
        (!_ctx.isDocPage)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_KTMenu)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDocPage)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode("h1", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_router_link, {
                  to: "/documentation/changelog",
                  class: "badge badge-light-danger bg-hover-danger text-hover-white fw-bold fs-9 px-2 ms-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("v" + _toDisplayString(_ctx.version), 1)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_12,
              _createVNode("ul", _hoisted_13, [
                _createVNode("li", _hoisted_14, _toDisplayString(_ctx.title), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_15, [
          (
              _ctx.authenticatedUser.validated_email &&
                (_ctx.$route.name === 'dashboard' || _ctx.$route.name === 'organization')
            )
            ? (_openBlock(), _createBlock("a", _hoisted_16, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(_ctx.translate("planificationGuide")), 1)
              ]))
            : _createCommentVNode("", true),
          (
              _ctx.authenticatedUser.validated_email && _ctx.$route.name === 'dashboard'
            )
            ? (_openBlock(), _createBlock("button", _hoisted_18, [
                _hoisted_19,
                _createTextVNode(" " + _toDisplayString(_ctx.translate("createOrganization")), 1)
              ]))
            : _createCommentVNode("", true),
          (
              _ctx.authenticatedUser.validated_email &&
                _ctx.$route.name === 'organization' &&
                _ctx.isPlanning
            )
            ? (_openBlock(), _createBlock("button", {
                key: 2,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openObjectiveModalOmi())),
                type: "button",
                class: "btn btn-success btn-sm ms-4",
                "data-bs-toggle": "modal",
                "data-bs-target": "#_app_objective_modal_omi"
              }, [
                _hoisted_20,
                _createTextVNode(" " + _toDisplayString(_ctx.translate("createObjective")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode(_component_KTTopbar)
        ])
      ])
    ]),
    _createVNode(_component_ELearningHelperModal)
  ]))
}